import classNames from 'classnames';
import { navigate } from 'gatsby';
import React, { useState, useEffect, useRef } from 'react';
import useDropdownMenu from 'react-accessible-dropdown-menu-hook';

import styles from './helper-widget.module.scss';
// icons
import CloseIcon from './svg/close.inline.svg';
import Cloud from './svg/cloud.inline.svg';
import Message from './svg/message.inline.svg';
import OpenIcon from './svg/open.inline.svg';
import Slack from './svg/slack.inline.svg';

const CHAT_ONLY_PATHS = [
  //  '/cloud',
  //  '/cloud/',
  // '/docs/cloud',
  //  '/docs/cloud/',
  // '/pricing',
  // '/pricing/',
];

const ANIMATION_PATHS = ['/contact'];

const HelperWidget = () => {
  // states
  const [shouldPing, setShouldPing] = useState(false);
  const { buttonProps, itemProps, isOpen, setIsOpen } = useDropdownMenu(3);

  const widgetRef = useRef(null);

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath && ANIMATION_PATHS.some((path) => currentPath.startsWith(path))) {
      setShouldPing(true);
    }
  }, []);

  const widgetClickOutside = (e) => {
    if (!widgetRef.current || !widgetRef.current.contains(e.target)) {
      setIsOpen(false);
      document.removeEventListener('click', widgetClickOutside);
    }
  };

  const handleCloudClick = () => navigate('/contact#contact-options');

  // handlers
  const handleOpenClick = () => {
    const showChatOnly = CHAT_ONLY_PATHS.some((path) => window.location.pathname.includes(path));
    if (showChatOnly) {
      handleCloudClick();
    } else {
      setIsOpen(true);
      document.addEventListener('click', widgetClickOutside);
    }
  };
  const handleCloseClick = () => {
    if (isOpen) {
      setIsOpen(false);
      document.removeEventListener('click', widgetClickOutside);
    }
  };
  const isPricingPath = CHAT_ONLY_PATHS.some((path) => {
    if (typeof window !== 'undefined') {
      return window.location.pathname.includes(path);
    }
    return false;
  });

  return (
    <div className={` ${isPricingPath ? `${styles.hiddenWrapper}` : `${styles.wrapper}`}`} ref={widgetRef}>
      <div className={styles.menuWrapper}>
        <button
          className={styles.button}
          type={'button'}
          onClick={isOpen ? handleCloseClick : handleOpenClick}
          {...buttonProps}
        >
          {shouldPing && (
            <>
              <i className={classNames(styles.circle, 'ping-animation')} />
              <i className={classNames(styles.circle, 'ping-animation')} />
              <i className={classNames(styles.circle, 'ping-animation')} />
            </>
          )}
          {!isOpen && <OpenIcon />}
          {isOpen && <CloseIcon />}
        </button>
        {isOpen && (
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <p className={styles.title}>Have a question?</p>
            </li>
            <li className={styles.listItem}>
              <a {...itemProps[0]} href={'https://community.grafana.com/'}>
                <Message />
                Community forum
              </a>
            </li>
            <li className={styles.listItem}>
              <a {...itemProps[1]} href={'https://k6.io/slack'} target={'_blank'} rel="noreferrer">
                <Slack />
                Community Slack
              </a>
            </li>
            <li className={styles.listItem}>
              <button {...itemProps[2]} type={'button'} onClick={handleCloudClick}>
                <Cloud />
                Cloud support
              </button>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default HelperWidget;
